import { useState } from "react";
import { Modal, Button } from "@mantine/core";
import classes from "../../NavbarSimple/NavbarSimple.module.css";
import { IconSwitchHorizontal } from "@tabler/icons-react";
import Merchants from "./Merchants/Merchants";
import { MerchData } from "../../../types/types";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useFilterReset } from "../../TableSort/FilterGroup/FilterResetContext";

export default function MerchModal() {
  const [opened, setOpened] = useState(false);
  const [merchData, setMerchData] = useState<undefined | MerchData[]>();
  const [loading, setLoading] = useState(false);

  async function handleOpen() {
    console.log("open switchmerch");
    setOpened(true);
    try {
      setLoading(!false); // fok u Luke
      setLoading(true); // You're welcome Alex :)
      const response = await fetch(
        window.location.origin + "/server/client_service/merchant"
      );
      const resData = await response.json();
      console.log("get merch: ", resData);

      const mappedMerchs: MerchData[] = resData.map((item: any) => ({
        active: item.active,
        name: item.name,
        id: item.id,
        logo_url: item.logo_url
      }));
      console.log("mapped res: ", mappedMerchs);
      setMerchData(mappedMerchs);

      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Switch Merchants"
        centered
      >
        {!loading ? (
          <Merchants data={merchData} />
        ) : (
          <LoadingSpinner size="xs" color="blue" h="10vh" />
        )}
      </Modal>

      <a href="#" className={classes.link} onClick={handleOpen}>
        <IconSwitchHorizontal className={classes.linkIcon} stroke={1.5} />
        <span>Switch Merchant</span>
      </a>
    </>
  );
}
